export default __webpack_public_path__ + "assets/xlsx.a3b00a8cd84f504b94d1cfc617b4080f.png";